import axios from "axios"
import config from '../lib/config.js'
import { AppenData, EncryptData, axiosFunc, localGet } from '../lib/common.js';

// purpose -- to get tokenlist  from db for listing before minting

export const getTokenList = async () => {

    try {
        const resp = await axiosFunc({
            'method': 'GET',
            'url': `${config.AdminAPI}/token/gettokens`,

        })

        return resp.data;
    }
    catch (err) {

    }

}

export const KYTDetails = async () => {

    try {
        const resp = await axiosFunc({
            'method': 'GET',
            'url': `${config.AdminAPI}/KYTDetails`,

        })
        return resp.data;
    }
    catch (err) {

    }

}

export const addarticle = async (data) => {
    try {
        const sendData = {
            'method': 'post',
            'url': `${config.AdminAPI}/addarticle`,
            "headers": {
                "Content-Type": 'multipart/form-data'
            },
            // 'data': data
        }
        const resp = await axiosFunc(sendData, data, true)
        return resp.data;
    }
    catch (err) {
        return false
    }
}

export const addaboutuser = async (data) => {
    try {
        // var formdata = AppenData(data)

        const sendData = {
            'method': 'post',
            'url': `${config.AdminAPI}/addaboutuser`,
            "headers": {
                "Content-Type": 'multipart/form-data',
                "Authorization": localGet("token")
            },
            // 'data': formdata[0]
        }
        const resp = await axiosFunc(sendData, data, true)
        return resp.data;
    }
    catch (err) {
        return false
    }
}

export const mintDbUpdate = async (payload) => {
    // var data = { "data": payload }

    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/token/afterMintUpdate`,
            // "data": payload,
            "headers": {
                "Authorization": localGet("token")
            }
        }
        var resp = await axiosFunc(sendData, payload)

        return resp.data;
    }
    catch (err) {
        // console.log("err in db updation", err)
    }

}


export const marketTokens = async () => {

    try {
        const resp = await axiosFunc({
            'method': 'GET',
            'url': `${config.AdminAPI}/token/getMarketTokens`,

        })

        return resp.data;
    }
    catch (err) {

    }

}


export const hideOrShowToken = async (data) => {
    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/token/hideshowtokens`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": data,

        }
        var resp = await axiosFunc(sendData, data)

        return resp.data;
    }
    catch (err) { 
        // console.log("errin hide show token", err)
     }

}


export const getTokenOwner = async (data) => {
    var data = { TokenId: data }

    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/getOwner`,
            // 'params': data
        }
        var resp = await axiosFunc(sendData, data)
        return resp.data;
    }
    catch (err) { 
        // console.log("err in gettok owner", err) 
    }
}


export const getShowStatus = async (data) => {


    console.log("data tokn id", data)
    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/token/getHideShow`,
            // 'params': data
        }
        var resp = await axiosFunc(sendData, data)
        return resp.data;
    }
    catch (err) {
        //  console.log("err in gettok owner", err) 
        }
}


export const addCategoryCall = async (data) => {
    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/addcategory`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": data,
        }
        var resp = await axiosFunc(sendData, data)
        return resp.data;
    }
    catch (err) { 
        // console.log("err in addin category", err)
     }

}

export const getCatList = async () => {

    try {
        var resp = await axiosFunc({

            'method': 'GET',
            'url': `${config.AdminAPI}/getcategory`,
        })
        return resp.data;
    }
    catch (err) {
        //  console.log("err in gettok owner", err) 
        }
}

export const hideShowCat = async (data) => {
    console.log("data cat", data)
    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/hideshowcategory`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": data,
        }
        var resp = await axiosFunc(sendData, data)

        return resp.data

    } catch (err) {
        // console.log("err in hide cat", err)
    }
}


export const addTokenCall = async (data) => {
    try {
        // const encData = EncryptData(data)
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/addtoken`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": { data: encData },
        }
        var resp = await axiosFunc(sendData, data)

        return resp.data
    }
    catch (err) {
        // console.log('add token err', err)
    }
}


export const getCurrencyList = async () => {

    try {
        var resp = await axiosFunc({
            'method': 'GET',
            'url': `${config.AdminAPI}/currencylist`,
        })
        return resp;
    }
    catch (err) {
        //  console.log("err in gettok owner", err) 
        }
}



export const editCmsCall = async (data) => {
    // var formdata = AppenData(data)

    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/editcms`,
            "headers": {
                "Content-Type": 'multipart/form-data',

                "Authorization": localGet("token")
            },
            // "data": formdata[0],
        }
        var resp = await axiosFunc(sendData, data, true)

        return resp
    }
    catch (err) {
        // console.log('add token err', err)
    }
}



export const getCmsContent = async (data) => {

    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/getcmslist`,
            // params: data
        }
        var resp = await axiosFunc(sendData, data)
        return resp;
    }
    catch (err) { 
        // console.log("err in gettok owner", err)
     }
}



export const getBurnTokens = async () => {

    try {
        var resp = await axiosFunc({

            'method': 'GET',
            'url': `${config.AdminAPI}/token/getburntokens`


        })
        return resp.data;
    }
    catch (err) { 
        // console.log("err in gettok owner", err) 
    }
}


export const getReportTokens = async () => {

    try {
        var resp = await axiosFunc({

            'method': 'GET',
            'url': `${config.AdminAPI}/getreporttokens`


        })
        return resp.data;
    }
    catch (err) { 
        // console.log("err in gettok owner", err)
     }
}



export const manageReportToken = async (data) => {
    try {
        const sendData = {
            "method": "POST",
            "url": `${config.AdminAPI}/managereporttoken`,
            "headers": {
                "Authorization": localGet("token")
            },
            // "data": data,
        }
        var resp = await axiosFunc(sendData, data)

        return resp.data
    }
    catch (err) {
        // console.log('add token err', err)
    }
}



export const tokenReportStatus = async (data) => {

    try {
        const sendData = {
            'method': 'GET',
            'url': `${config.AdminAPI}/getreportoftoken`,
            // 'params': data
        }
        var resp = await axiosFunc(sendData, data)
        return resp.data;
    }
    catch (err) { 
        // console.log("err in gettok owner", err) 
    }
}

/**  */

export const getDropList = async () => {
    try {
        const resp = await axiosFunc({
            'method': 'GET',
            'url': `${config.AdminAPI}/token/getDropList`,
        })
        return resp.data;
    }
    catch (err) {
        return false
    }

}


export const ApproveCAll = async (data) => {
    try {
        const sendData = {
            'method': 'post',
            'url': `${config.AdminAPI}/token/ApproveCAll`,
            // 'data': data
        }
        const resp = await axiosFunc(sendData, data)
        return resp.data;
    }
    catch (err) {
        return false
    }

}

export const CreateLazyMint = async (data) => {
    const sendData = {
        method: 'post',
        url: `${config.AdminAPI}/token/CreateLazyMint`,
        // data: data,
    }
    const resp = await axiosFunc(sendData, data)
    return resp.data;

}

export const getemailTemplateList = async () => {
    const resp = await axiosFunc({
        method: 'get',
        url: `${config.AdminAPI}/getemailtemplate`
    })
    return resp.data;
}



export const editemailTemplateList = async (data) => {
    const sendData = {
        method: 'post',
        url: `${config.AdminAPI}/editEmailTemplate`,
        // data: data,
    }
    const resp = await axiosFunc(sendData, data)
    return resp;

}

export const addEmailTemplate = async (data) => {
    const sendData = {
        method: 'post',
        url: `${config.AdminAPI}/addEmailTemplate`,
        // data: data,
    }
    const resp = await axiosFunc(sendData, data)
    return resp;

}

export const BannerPromotionAction = async (data) => {
    const sendData = {
        method: 'post',
        url: `${config.AdminAPI}/bannerpromotionaction`,
        // data: data,
    }
    const resp = await axiosFunc(sendData, data)
    return resp.data;
}

//addcmshome
export const addcmshome = async (data) => {
    // var formdata = AppenData(data)

    try {
        const sendData = {
            'method': 'post',
            'url': `${config.AdminAPI}/editcms`,
            "headers": {
                "Content-Type": 'multipart/form-data',
                "Authorization": localGet("token")
            },
            // 'data': formdata[0]
        }
        const resp = await axiosFunc(sendData, data, true)
        return resp;
    }
    catch (err) {
        return false
    }
}

export const onInitialMint = async (data) => {

    try {
        // const encData = EncryptData(data)
        var senddata = {
            method: 'POST',
            url: `${config.Back_Url}/front/nft/onInitialMint`,
            // data: { data: encData }
        }
        let Resp = await axiosFunc(senddata, data)
        return Resp
    } catch (e) {
        // console.log("onInitialMint error", e);
    }

}

export const Buymint = async (data) => {
    try {
        // const encData = EncryptData(data)
        var senddata = {
            method: 'POST',
            url: `${config.Back_Url}/front/nft/Buymint`,
            // data: { data: encData }
        }
        let Resp = await axiosFunc(senddata, data)
        return Resp
    } catch (e) {
        // console.log("err on Buymint", e);
    }

}